/* tslint:disable */
/* eslint-disable */
/**
 * Vantis.HR.HttpApi.Host
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Configuration } from "./configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import globalAxios from 'axios';
export const BASE_PATH = "/".replace(/\/+$/, "");
/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    configuration;
    axios;
    basePath;
    constructor(configuration, basePath, axios) {
        if (!configuration && Configuration.globalConfiguration) {
            configuration = Configuration.globalConfiguration;
        }
        this.basePath = basePath || BASE_PATH;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
        this.axios = axios || this.configuration?.axiosInstance || globalAxios;
    }
}
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    field;
    name = "RequiredError";
    constructor(field, msg) {
        super(msg);
        this.field = field;
    }
}
export const encodeURIComponentString = (input) => {
    if (input === undefined) {
        return '';
    }
    if (input instanceof Date) {
        return input.toJSON();
    }
    return String(input);
};
